import { MediaFilter } from "../MediaFilter/MediaFilter"
import { MediaGrid } from "../MediaGrid/MediaGrid";
import { MediaList } from "../MediaList/MediaList"
import cls from 'clsx';
import { useMediaParams } from "./useMediaParams";
import { MediaSearchOrder, MediaSearchQuery, MediaType } from "@jconradi/tutu-porn-api-client/src/media";
import { lazy, useContext, useEffect, useId } from "react";
import RandomSeed from 'seedrandom';
import slugify from "slugify";
import { MediaViewType } from "../MediaFilter/MediaViewType";
import { Pagination } from "../../Pagination/Pagination";
import { useMediaSearch } from "../../../hooks/useMediaSearch";
import { BannerAd } from "../../Ads/Exoclick/BannerAd";
import { WatchContext } from "../../../contexts/WatchContext";
import { TutuModelVideo } from "@jconradi/tutu-porn-components/services/api/tutu-models/tutu-models";

export interface FeedProps {
    className?: string;
    username?: string;
    loading?: boolean;
    query: MediaSearchQuery;
    tutuAds?: TutuModelVideo[];
}
const Feed = ({ className, username, loading = false, query, tutuAds }: FeedProps) => {
    const mediaParams = useMediaParams(query);
    const { page, setPage } = mediaParams;
    const { searchTags } = useContext(WatchContext);

    const hookQueryInitial: any = {
        username,
        order: Object.values(MediaSearchOrder).includes(mediaParams.order as MediaSearchOrder)
        ? mediaParams.order as MediaSearchOrder : MediaSearchOrder.Top,
        type: Object.values(MediaType).includes(mediaParams.type as MediaType)
        ? mediaParams.type as MediaType : undefined,
        verified: mediaParams.verified || undefined,
        horizontal: mediaParams.horizontal || undefined,
        vertical: mediaParams.vertical || undefined,
        count: mediaParams.count,
        page: mediaParams.page - 1,
        approved: mediaParams.unapproved === true ? false : undefined,
        transcoding: mediaParams.transcoding
    };

    if (searchTags.length > 0) {
        hookQueryInitial.tags = searchTags.map(t => slugify(t, {
            lower: true
        }));
    }

    const hookQuery = Object.entries(hookQueryInitial)
        .filter(([key, value]) => value !== undefined)
        .reduce((obj: any, [key, value]) => {
            obj[key] = value;
            return obj;
        }, {});

    const mediaQuery = useMediaSearch(hookQuery, loading);
    const id = useId();
    const rand = RandomSeed(JSON.stringify(hookQuery));
    const tutuAd = tutuAds ? tutuAds[Math.floor(rand() * tutuAds.length)] : undefined;

    return (
            <div className={cls("flex-1 w-full", className)}>
                <MediaFilter {...mediaParams} />

                {mediaParams.view === MediaViewType.List &&
                    <MediaList tutuAds={tutuAds} loading={loading} query={hookQuery} />
                }
                {mediaParams.view === MediaViewType.Grid &&
                    <MediaGrid tutuAd={tutuAd} loading={loading} query={hookQuery} />
                }

                {!mediaQuery.isLoading && 
                    <Pagination 
                        page={page} 
                        totalPages={Math.ceil(mediaQuery.data?.totalMedia! / (mediaParams.count))} 
                        onPageChange={(page) => setPage(page)} />
                }

            </div>
    )
}

export const MediaFeed = (props: any) =>  <Feed {...props} />;
